import React, { forwardRef } from "react";
import styled from "styled-components";
import IBuildrProps from "../../utilities/IBuildrProps";
import classNames from "classnames";

interface IBranchDataProps extends IBuildrProps {
    title;
    children;
}

const BranchData = styled(forwardRef(({ title, children, className, editorClassObj, cmsId }: IBranchDataProps, ref: any) => {
    return (
        <div data-id={cmsId} ref={ref} className={classNames("mb-4", className, editorClassObj)}>
            <div className="mb-2">
                <strong>{title}</strong>
            </div>
            <div className="branch-data-body">
                {children}
            </div>
        </div>
    );
}))`
    .branch-data-body {
        line-height: 1.8rem;
    }
`;

export default BranchData;
(global as any).BranchData = BranchData;